<script lang="ts">
  import { __ } from '@wordpress/i18n';

  type Props = {
    isReseller: boolean;
    onToggle: (reseller: boolean) => void;
  };

  let { isReseller, onToggle }: Props = $props();
</script>

<div class="wpc-admin-price-toggle">
  <button
    type="button"
    class="wpc-admin-price-toggle__btn"
    class:wpc-admin-price-toggle__btn--reseller={isReseller}
    onclick={() => onToggle(!isReseller)}
    title={isReseller ? __('Reseller prijzen actief', 'wpc') : __('Standaard prijzen actief', 'wpc')}
  >
    <span class="wpc-admin-price-toggle__icon">
      {#if isReseller}
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
      {:else}
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
      {/if}
    </span>
    <span class="wpc-admin-price-toggle__label">
      {isReseller ? __('Reseller', 'wpc') : __('Klant', 'wpc')}
    </span>
  </button>
</div>

<style>
  .wpc-admin-price-toggle {
    position: fixed;
    bottom: 20px;
    left: 20px;
    z-index: 9999;
  }

  .wpc-admin-price-toggle__btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    border: none;
    border-radius: 20px;
    background: #1d2327;
    color: #fff;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    transition: background 0.2s, transform 0.1s;
    line-height: 1;
  }

  .wpc-admin-price-toggle__btn:hover {
    background: #2c3338;
    transform: translateY(-1px);
  }

  .wpc-admin-price-toggle__btn--reseller {
    background: #2271b1;
  }

  .wpc-admin-price-toggle__btn--reseller:hover {
    background: #135e96;
  }

  .wpc-admin-price-toggle__icon {
    display: flex;
    align-items: center;
  }

  .wpc-admin-price-toggle__label {
    white-space: nowrap;
  }
</style>
